// Reading the colour fields (ai/shared/_color_field) and the contrast warnings under them, shared by
// contrast_check_controller.js and accessibility_check_controller.js.

// A field's stored colour, "" while it is blank.
export function valueOf(root) {
  return root?.querySelector("[data-color-field-target='value']")?.value || ""
}

// A field's colour as the check sees it: its value, else its default (which contrast-check keeps current).
export function colorOf(root) {
  return valueOf(root) || root?.dataset.colorFieldDefaultValue || ""
}

// The colours a warning's field is drawn on: other fields, each read with `colorOfAttribute`, and/or a fixed
// colour.
export function backgroundsOf(warning, colorOfAttribute) {
  const { contrastCheckAgainst: against = "", contrastCheckAgainstColor: againstColor } = warning.dataset
  const fields = against.split(" ").filter(Boolean).map(colorOfAttribute)
  return againstColor ? [...fields, againstColor] : fields
}
